export default __webpack_public_path__ + "static/media/coffee.d91a6372.jpeg";